import { inject, Injectable } from '@angular/core';
import { SmartRiskService } from '@app/core/services';
import * as fromRoot from '@app/store/reducers';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { Store } from '@ngrx/store';
import { throwError } from 'rxjs';
import { catchError, map, switchMap, withLatestFrom } from 'rxjs/operators';

import { CategoriesActions } from '../actions';
import { getAllCategories } from '../reducers';

@Injectable()
export class CategoryEffects {
  readonly actions$ = inject(Actions);
  readonly store = inject<Store<fromRoot.State>>(Store);
  readonly smartRiskService = inject(SmartRiskService);

  loadCategories$ = createEffect(() =>
    this.actions$.pipe(
      ofType(CategoriesActions.loadCategories),
      withLatestFrom(this.store.select(getAllCategories)),
      switchMap(() =>
        this.smartRiskService.getCategories().pipe(
          map(categories => CategoriesActions.loadCategoriesSuccess({ categories })),
          catchError(error => throwError(error))
        )
      )
    )
  );
}
